import { Paragraph, TextRun } from "docx";
import generateLvTableRow from "./generateLvTableRow";
import ConvertToString from "../Converter";

export default function generateRequirementsRows(lvData, startingPositionNumber) {
  const descriptionParagraphAdditionalCementConsumption = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Zementmehrverbrauch",
        bold: true,
      }),
      new TextRun({
        text: "Mehrverbrauch ist sofort anzukündigen. Differenz des benötigten Zementverbrauchs als Zuschlag zur Mikropfahlposition bei nachweislicher Abweichung des Baugrunds zwischen dem Ist- und Soll-Zustand. Abrechnung nach VOB. Abrechnung entsprechend Lieferschein.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphAdditionalLenghts = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Mehrlängen",
        bold: true,
      }),
      new TextRun({
        text: "Mehr- bzw. Minderlängen gegenüber der Mikropfahl-Position bei nachgewiesener Abweichung des vorhandenen Baugrundes vom Baugrundgutachten liefern und herstellen.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphDrillingIntoRock = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Bohren in Fels",
        bold: true,
      }),
      new TextRun({
        text: "Herstellung in Fels gemäß Absprache mit dem AG einschließlich der Materialien und wechseln der Bohrkronen. Erhöhter Materialverschleiß ist einzurechnen.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphDrillingThroughObstacles = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Durchbohren von Hindernissen",
        bold: true,
      }),
      new TextRun({
        text: "Durchbohren von Hindernissen in Absprache mit dem AG einschließlich der Materialien und wechseln der Bohrkronen. Erhöhter Materialverschleiß ist einzurechnen.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphDowntimesEquipmentAndWorkforce = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Stillstandzeiten",
        bold: true,
      }),
      new TextRun({
        text: "Stillstandzeit eines Bohrgeräts mit Bedienungspersonal und Betriebsstoffen infolge Bohrhindernissen und sonstigen Behinderungen, die der AG zu vertreten hat.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphDowntimesEquipmentOnly = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Stillstandzeiten",
        bold: true,
      }),
      new TextRun({
        text: "Stillstandzeit eines Bohrgeräts wie vor, jedoch ohne Bedienungspersonal und Betriebsstoffen für die Beseitigung von Hindernissen und sonstigen Behinderungen, die der AG zu vertreten hat.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphDisposalDrillingSlurry = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Entsorgung Bohrsuspension",
        bold: true,
      }),
      new TextRun({
        text: "Auffangen und Entsorgen der anfallenden Bohrsuspension der Mikropfähle.",
        break: 1,
      }),
    ],
  });

  const descriptionParagraphExecutionStatistics = new Paragraph({
    children: [
      new TextRun({
        text: "***Bedarfsposition Ausführungsstatik",
        bold: true,
      }),
      new TextRun({
        text: "Erstellen einer prüffähigen Ausführungsstatik in 3-facher Ausfertigung.",
        break: 1,
      }),
    ],
  });

  let tableRows = [];

  let positionNumber = startingPositionNumber;

  if (lvData.includeAdditionalCementConsumption) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphAdditionalCementConsumption,
        ConvertToString(lvData.additionalCementConsumption),
        "kg"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeAdditionalLengths) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphAdditionalLenghts,
        ConvertToString(lvData.additionalLengths),
        "m"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeDrillingIntoRock) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphDrillingIntoRock,
        ConvertToString(lvData.drillingIntoRock),
        "m"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeDrillingThroughObstacles) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphDrillingThroughObstacles,
        ConvertToString(lvData.drillingThroughObstacles),
        "m"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeDowntimesEquipmentAndWorkforce) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphDowntimesEquipmentAndWorkforce,
        ConvertToString(lvData.downtimesEquipmentAndWorkforce),
        "Std"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeDowntimesEquipmentOnly) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphDowntimesEquipmentOnly,
        ConvertToString(lvData.downtimesEquipmentOnly),
        "Std"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeDisposalDrillingSlurry) {
    tableRows.push(
      generateLvTableRow(
        positionNumber,
        descriptionParagraphDisposalDrillingSlurry,
        ConvertToString(lvData.disposalDrillingSlurry),
        "m³"
      )
    );
    positionNumber += 10;
  }

  if (lvData.includeExecutionStatistics) {
    tableRows.push(
      generateLvTableRow(positionNumber, descriptionParagraphExecutionStatistics, "1", "psch")
    );

    positionNumber += 10;
  }

  tableRows.push(generateLvTableRow(positionNumber, "", "", ""));

  return tableRows;
}
